<template>
  <l-modal :showing="showing" text="Edit calculated timeserie" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full flex flex-col text-xs">      
      <div class="flex mb-4">
        <div class="w-full mr-4">        
          <b>Primary</b><br>
          <l-select v-model="editObj.primary" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
            <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Operator</b><br>
          <l-select v-model="editObj.operator" class="text-xs" :data="operators" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in operators" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Secondary</b><br>
          <l-select v-model="editObj.secondary" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full">        
          <b>Result</b><br>
          <l-select v-model="editObj.result" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
      </div>
      
      <div class="flex w-full justify-between">
        <div>
          <l-button type="success" :disabled="!editObj.primary || !editObj.operator || !editObj.secondary || !editObj.result" @click="onSave">Save changes</l-button>&nbsp;
        </div>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox"


export default {
  name: "LLEdit",
  props: [
    "showing",
    "stations",
    "timeserie",
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption,
    LInfoBox
  },
  data() {
    return {
      operators: [ { label:'-', value: '-' }, { label:'+', value: '+' } ],
    }
  },
  computed: {        
    editObj: function() {
      return Object.assign({}, this.timeserie);
    },
    timeseries() {
      const sel = this.stations.find(t => {
        return t.value == this.editObj.sta_id;
      });
      if (!sel) return [];
      
      return sel.timeseries;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      this.$emit("save", this.editObj);
      this.close();
    },
  }
};
</script>